import { render } from "./AppointmentConsumablesForm.vue?vue&type=template&id=6f1fca2e"
import script from "./AppointmentConsumablesForm.vue?vue&type=script&lang=js"
export * from "./AppointmentConsumablesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__